import { Button, Icons, Table, Typography, useTable } from '@pankod/refine-antd'
import React from 'react'
import { useRouter } from 'next/router'

import AktivitasDrawer, { useAktivitasDrawer } from './AktivitasDrawer'

const LaporanPresensi = () => {
  const router = useRouter()
  const programId = String(router.query?.programId)
  const { tableProps } = useTable<{ id: string; name: string }>({
    dataProviderName: 'lms',
    resource: `programs/${programId}/program-modules`,
    queryOptions: {
      enabled: !!programId,
    },
  })
  const { show, ...aktivitasDrawerProps } = useAktivitasDrawer()
  return (
    <>
      <Typography.Title level={5} className="!mb-3">
        Daftar Modul
      </Typography.Title>
      <Table
        {...tableProps}
        rowKey="id"
        bordered
        columns={[
          {
            title: 'Nama Modul',
            dataIndex: 'name',
            width: '80%',
          },
          {
            title: 'Laporan Aktivitas',
            align: 'center',
            render: (_, record) => {
              return (
                <Button
                  icon={<Icons.UnorderedListOutlined />}
                  onClick={() => {
                    show(record.id, record.name)
                  }}
                >
                  Lihat Daftar Aktivitas
                </Button>
              )
            },
          },
        ]}
      />
      <AktivitasDrawer
        {...aktivitasDrawerProps}
        key={aktivitasDrawerProps.id}
      />
    </>
  )
}

export default LaporanPresensi
